import { IPeriod, VeckoSchemaPerioder, WeekDayName } from "../types/module-type";

export const dayNameTranslation = {
  monday: "Måndag",
  tuesday: "Tisdag",
  wednesday: "Onsdag",
  thursday: "Torsdag",
  friday: "Fredag",
  saturday: "Lördag",
  sunday: "Söndag",
};

export const minutesToString = (minutes: number): string => {
  const bookH = Math.floor(minutes / 60).toLocaleString("sv-SE", {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });
  const bookM = (minutes % 60).toLocaleString("sv-SE", {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });
  const bookingDurationToHour = bookH + ":" + bookM;

  return bookingDurationToHour;
};

export const stringToMinutes = (time: string): number => {
  var minutes = parseInt(time.split(":")[0]) * 60 + parseInt(time.split(":")[1]);

  return minutes;
};

export const periodToMinutes = (period: IPeriod): number => {
  var diffInMinutes = stringToMinutes(period.end) - stringToMinutes(period.start);
  return diffInMinutes;
};
export const sumPeriods = (periods: IPeriod[]): number => {
  const tot = periods.reduce((agg, cur) => agg + periodToMinutes(cur), 0);
  return tot; //minutesToString(tot);
};

const periodsInSpan = (periods: IPeriod[], periodStart: number, periodEnd: number): IPeriod[] => {
  // const periodStart = stringToMinutes(period.start);
  // const periodEnd = stringToMinutes(period.end);

  const overLapPs = periods.filter((p) => {
    const start = stringToMinutes(p.start);
    const end = stringToMinutes(p.end);
    return !(start > periodEnd || end < periodStart);
  });
  return overLapPs;
};

export const sumSchedule = (schedule: VeckoSchemaPerioder, filterType: string | undefined): number => {
  let tot = 0;
  Object.keys(WeekDayName).forEach((wd) => {
    let periods = schedule[wd as WeekDayName];
    if (filterType) periods = periods?.filter((p) => p.typ === filterType);
    if (periods) {
      const dayTot = sumPeriods(periods);
      tot += dayTot;
    }
  });

  return tot;
};

export const compareNärvaroOchDriftPeriods = (wdNärvaroPerioder: IPeriod[], wdVentilationPerioder: IPeriod[]) => {
  let sumNärvaro = 0;
  let närvaroVentilationOverLap = 0;
  let sumVentilation = sumPeriods(wdVentilationPerioder);
  wdNärvaroPerioder.forEach((pNärvaro) => {
    const närvaroStart = stringToMinutes(pNärvaro.start);
    const närvaroEnd = stringToMinutes(pNärvaro.end);
    sumNärvaro += närvaroEnd - närvaroStart;
    wdVentilationPerioder.forEach((pVentilation) => {
      const ventilationStart = stringToMinutes(pVentilation.start);
      const ventilationEnd = stringToMinutes(pVentilation.end);

      let overlap = 0;
      if (ventilationStart < närvaroStart && ventilationEnd > närvaroEnd) {
        //VentInterval överlappar på båda sidor
        overlap = närvaroEnd - närvaroStart;
      } else if (ventilationStart > närvaroStart && ventilationEnd < närvaroEnd) {
        //VentInterval innesluten i närvaro-interval
        overlap = ventilationEnd - ventilationStart;
      } else if (ventilationStart <= närvaroStart && ventilationEnd >= närvaroStart) {
        //VentInterval överlappar start på närvaro
        overlap = ventilationEnd - närvaroStart;
      } else if (ventilationStart <= närvaroEnd && ventilationEnd >= närvaroEnd) {
        overlap = närvaroEnd - ventilationStart;
        //VentInterval överlappar slut på närvaro
      }
      närvaroVentilationOverLap += overlap;
    });
  });

  //Find excessive ventilation time outside of närvaro time
  const buffer = 60;
  let underVentilation = 0;
  let overVentilation = 0;
  let overVentilationHelfart = 0;
  let overVentilationDelfart = 0;

  wdVentilationPerioder.forEach((ventP) => {
    const ventStart = stringToMinutes(ventP.start);
    const ventEnd = stringToMinutes(ventP.end);

    const presencePs = periodsInSpan(wdNärvaroPerioder, ventStart - buffer, ventEnd + buffer);
    if (presencePs.length === 0) {
      // overVentilation += ventEnd - ventStart;
      if (ventP.typ === "Helfart") overVentilationHelfart += ventEnd - ventStart;
      if (ventP.typ === "Delfart") overVentilationDelfart += ventEnd - ventStart;
      return;
    }

    let minStart = ventEnd;
    let maxEnd = ventStart;
    let overMinutes = 0;

    if (presencePs.length < 2) {
      minStart = stringToMinutes(presencePs[0].start);
      maxEnd = stringToMinutes(presencePs[0].end);
    } else {
      for (let i = 0; i < presencePs.length; i++) {
        const presStart = stringToMinutes(presencePs[i].start);
        const presEnd = stringToMinutes(presencePs[i].end);
        minStart = Math.min(minStart, presStart);
        maxEnd = Math.max(maxEnd, presEnd);

        if (i < presencePs.length - 1) {
          const nextPresStart = stringToMinutes(presencePs[i + 1].start);
          let gapMinutes = nextPresStart > presEnd ? nextPresStart - presEnd : 0;
          gapMinutes = gapMinutes < buffer * 2 ? 0 : gapMinutes - buffer * 2;
          overMinutes += gapMinutes;
        }
      }
    }
    minStart = minStart - buffer;
    maxEnd = maxEnd + buffer;
    if (minStart > ventStart) {
      overMinutes += minStart - ventStart;
    }
    if (maxEnd < ventEnd) {
      overMinutes += ventEnd - maxEnd;
    }
    if (ventP.typ === "Helfart") overVentilationHelfart += overMinutes;
    if (ventP.typ === "Delfart") overVentilationDelfart += overMinutes;
    //overVentilation += overMinutes;
  });

  wdNärvaroPerioder.forEach((presence) => {
    const presenceStart = stringToMinutes(presence.start);
    const presenceEnd = stringToMinutes(presence.end);

    const ventPs = periodsInSpan(wdVentilationPerioder, presenceStart, presenceEnd);
    if (ventPs.length === 0) {
      underVentilation += presenceEnd - presenceStart;
      return;
    }

    let ventMinStart = presenceEnd;
    let ventMaxEnd = presenceStart;
    let missingMinutes = 0;

    if (ventPs.length < 2) {
      ventMinStart = stringToMinutes(ventPs[0].start);
      ventMaxEnd = stringToMinutes(ventPs[0].end);
    } else {
      for (let i = 0; i < ventPs.length; i++) {
        const ventStart = stringToMinutes(ventPs[i].start);
        const ventEnd = stringToMinutes(ventPs[i].end);
        ventMinStart = Math.min(ventMinStart, ventStart);
        ventMaxEnd = Math.max(ventMaxEnd, ventEnd);

        if (i < ventPs.length - 1) {
          const nextVentStart = stringToMinutes(ventPs[i + 1].start);
          const gapMinutes = nextVentStart > ventEnd ? nextVentStart - ventEnd : 0;
          missingMinutes += gapMinutes;
        }
      }
    }
    if (ventMinStart > presenceStart) {
      missingMinutes += ventMinStart - presenceStart;
    }
    if (ventMaxEnd < presenceEnd) {
      missingMinutes += presenceEnd - ventMaxEnd;
    }
    underVentilation += missingMinutes;
  });

  overVentilation += overVentilationHelfart + overVentilationDelfart;
  return { sumNärvaro, närvaroVentilationOverLap, sumVentilation, overVentilation, underVentilation, overVentilationHelfart, overVentilationDelfart };
};

export const compareNärvaroOchDrift = (närvaro: VeckoSchemaPerioder | undefined, ventilation: VeckoSchemaPerioder | undefined): any => {
  const result = {} as any;

  if (!närvaro || !ventilation) return result;
  Object.keys(WeekDayName).forEach((wd) => {
    const wdNärvaroPerioder = närvaro[wd as WeekDayName];
    const wdVentilationPerioder = ventilation[wd as WeekDayName];
    if (wdNärvaroPerioder && wdVentilationPerioder) {
      const wdResult = compareNärvaroOchDriftPeriods(wdNärvaroPerioder, wdVentilationPerioder);
      // if (wdResult.sumNärvaro > wdResult.närvaroVentilationOverLap) result[wd] = { närvaroEjTäckt: wdResult.sumNärvaro - wdResult.närvaroVentilationOverLap };
      // if (wdResult.sumVentilation > wdResult.sumNärvaro + 120) result[wd] = { ...(result[wd] || {}), ...{ excessiveVentilation: wdResult.sumVentilation - wdResult.sumNärvaro } };
      if (wdResult.underVentilation > 0) result[wd] = { närvaroEjTäckt: wdResult.underVentilation };
      if (wdResult.overVentilation > 0) result[wd] = { ...(result[wd] || {}), ...{ excessiveVentilation: wdResult.overVentilation } };
      if (wdResult.overVentilationHelfart > 0) result[wd] = { ...(result[wd] || {}), ...{ excessiveVentilationHelfart: wdResult.overVentilationHelfart } };
      if (wdResult.overVentilationDelfart > 0) result[wd] = { ...(result[wd] || {}), ...{ excessiveVentilationDelfart: wdResult.overVentilationDelfart } };
    }
  });

  return result;
};
